import React from "react";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {EditElementModalForm} from "../EditElementModalForm";

export class EditAvailableFundsForm extends EditElementModalForm {

    constructor(props) {
        super(props);
        this.state = {
            availableFunds: this.props.availableFunds,
            loading: false,
            saving: false
        };

        this.handleAmountChange = this.handleAmountChange.bind(this);
    }

    getSubmitUrl() {
        return API_URL + `business-unit/${this.props.businessUnitId}/modify-available-funds/`;
    }

    getDataToSubmit(event) {
        return {'amount': this.state.availableFunds};
    }

    renderSaveButton() {
        if (this.state.saving === false) {
            return <input type="submit" value="Actualizar" className="btn -submit"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    handleAmountChange = (event) => {
        const possibleNewValue = parseFloat(event.target.value.replace(/\D/g, '')); // Remove non-digit characters
        let newValue = event.target.value;
        if (!isNaN(possibleNewValue)) {
            newValue = possibleNewValue;
        }

        this.setState({
            availableFunds: newValue
        });
    };

    renderFormFields() {
        if (this.state.loading === true) {
            return <Spinner color="positive small"/>;
        }

        let formattedValue = this.state.availableFunds;
        if (this.state.availableFunds !== null) {
            formattedValue = Number(this.state.availableFunds).toLocaleString('en-US');
        }

        return <div className="modal-section">
            <div className="form-row mb-0 pb-0">
                <label>Saldo disponible:</label>
            </div>
            <div className="form-row">
                <input
                    min="0"
                    name="amount"
                    type="text"
                    className="form-control"
                    id="amount"
                    value={formattedValue}
                    onChange={this.handleAmountChange}
                    required="required"
                />
            </div>
        </div>;
    }
}
